import React, { useState, useEffect } from 'react';
import { X, ArrowRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const ExitIntentPopup = () => {
  const [showPopup, setShowPopup] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    // Check if user has already seen the popup twice
    const popupCount = parseInt(localStorage.getItem('exitIntentCount') || '0');
    if (popupCount >= 2) return; // Stop after 2 times

    let firstTimer = null;
    let secondTimer = null;

    // First popup: after 3 minutes (180000 ms)
    if (popupCount === 0) {
      firstTimer = setTimeout(() => {
        setShowPopup(true);
        localStorage.setItem('exitIntentCount', '1');
      }, 180000); // 3 minutes
    }
    // Second popup: after 5 more minutes (300000 ms)
    else if (popupCount === 1) {
      secondTimer = setTimeout(() => {
        setShowPopup(true);
        localStorage.setItem('exitIntentCount', '2');
      }, 300000); // 5 minutes
    }

    return () => {
      if (firstTimer) clearTimeout(firstTimer);
      if (secondTimer) clearTimeout(secondTimer);
    };
  }, []);

  const handleClose = () => {
    setShowPopup(false);
  };

  const handleCTA = () => {
    setShowPopup(false);
    navigate('/assessment');
  };

  if (!showPopup) return null;

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center p-4 bg-black/50 animate-fadeIn">
      <div className="relative bg-white rounded-2xl shadow-2xl max-w-md w-full p-8 animate-scaleIn">
        <button
          onClick={handleClose}
          className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors"
          aria-label="Close"
        >
          <X size={24} />
        </button>

        <div className="text-center">
          <div className="text-5xl mb-4">🚀</div>
          <h3 className="text-2xl font-bold text-gray-900 mb-3">
            Wait! Before You Go...
          </h3>
          <p className="text-gray-600 mb-6">
            Take our free 5-minute assessment to discover how we can help your project.
          </p>
          <button
            onClick={handleCTA}
            className="w-full px-6 py-3 bg-[#0B3F84] text-white font-semibold rounded-lg hover:bg-[#0a3570] transition-colors inline-flex items-center justify-center gap-2 mb-3"
          >
            Start Free Assessment
            <ArrowRight size={20} />
          </button>
          <button
            onClick={handleClose}
            className="text-gray-500 hover:text-gray-700 text-sm"
          >
            No thanks, I'll pass
          </button>
        </div>
      </div>
    </div>
  );
};

export default ExitIntentPopup;
